<template>
  <div
    class="flex flex-col self-stretch p-6 pt-4 gap-4 bg-primary border-b border-secondary"
    :class="{
      'p-4 pt-6': viewport !== 'desktop',
      'p-6 pt-4': viewport === 'desktop',
      'lg:p-6 lg:pt-4': viewport === 'reactive',
    }"
  >
    <div class="w-full flex gap-5">
      <div
        class="position-relative"
        :class="
          !readonly &&
          (getVariant(variant) === 'asset' ||
            getVariant(variant) === 'space') &&
          'cursor-pointer'
        "
        @click="
          !readonly &&
            (getVariant(variant) === 'asset' ||
              getVariant(variant) === 'space') &&
            $emit('goToStep', 'profile_image')
        "
      >
        <div
          v-if="
            !readonly &&
            (getVariant(variant) === 'asset' || getVariant(variant) === 'space')
          "
          class="border border-secondary rounded-md position-absolute p-1.5 right-0 bg-secondary"
        >
          <Icon name="camera" size="sm" />
        </div>
        <Indicator
          :variant="variant"
          size="3xl"
          mode="transparent"
          :imageUrl="imageUrl"
          :class="{
            'rounded-3xl mt-1 mr-1':
              !readonly &&
              (getVariant(variant) === 'asset' ||
                getVariant(variant) === 'space'),
          }"
        />
      </div>
      <div class="w-full flex flex-col justify-center gap-1 overflow-hidden">
        <EditableTextArea
          :key="form.name"
          :defaultValue="form.name"
          :maxLength="200"
          :readonly="readonly"
          submitMode="both"
          class="text-primary text-style-2xl font-medium"
          @update="handleUpdate('name', $event)"
        />
        <div
          v-if="!readonly && (variant === 'asset' || variant === 'space')"
          class="flex items-center"
        >
          <EditableIdBadge
            :key="form.identifier"
            :value="form.identifier"
            :readonly="readonly"
            :viewport="viewport"
            @update="handleUpdate('identifier', $event)"
          />
        </div>
      </div>
    </div>
    <PassportInsightsGrid :viewport="viewport">
      <slot />
    </PassportInsightsGrid>
  </div>
</template>

<script setup>
import { useForm } from "@inertiajs/vue3";
import { Indicator } from "@/SharedComponents/Indicator";
import { EditableTextArea } from "@/SharedComponents/Inputs";
import {
  EditableIdBadge,
  PassportInsightsGrid,
} from "@/SharedComponents/Passport";
import { Icon } from "@/SharedComponents/Icon";

const emit = defineEmits(["update", "goToStep"]);

const props = defineProps({
  variant: { type: String, required: true },
  name: { type: String, required: true },
  identifier: { type: String, required: true },
  imageUrl: { type: String, required: false },
  readonly: { type: Boolean, required: false },
  viewport: {
    type: String,
    validator: (val) => ["mobile", "desktop", "reactive"].includes(val),
    default: "reactive",
  },
});

const form = useForm({
  name: props.name,
  ...(props.variant === "asset" || props.variant === "space"
    ? { identifier: props.identifier }
    : {}),
});

function handleUpdate(key, value) {
  form[key] = value;
  emit("update", {
    data: form.data(),
    callback: (success) => {
      success && form.defaults(key, value);
      form.reset(key);
    },
  });
}

const getVariant = (data) => {
  switch (data) {
    case "asset_group":
    case "asset":
      return data;
    default:
      return "space";
  }
};
</script>
